/**
 * 国家和城市数据
 * 提供全球热门国家和城市的静态数据
 * 这是纯数据文件，可在 Web 和 Mobile 端共享
 */

export interface CountryData {
  code: string;
  nameKey: string; // i18n 翻译键
  flag: string;
  cityKeys: string[]; // 城市 i18n 翻译键数组
}

/**
 * 全球热门国家和城市数据
 * 数据按地区组织，便于筛选和搜索
 */
export const COUNTRIES_DATA: CountryData[] = [
  // 亚洲热门国家
  {
    code: 'CN',
    nameKey: 'destinations.countries.CN',
    flag: '🇨🇳',
    cityKeys: [
      'destinations.cities.Beijing',
      'destinations.cities.Shanghai',
      'destinations.cities.Guangzhou',
      'destinations.cities.Shenzhen',
      'destinations.cities.Hangzhou',
      'destinations.cities.Chengdu',
      'destinations.cities.Xian',
      'destinations.cities.Chongqing',
      'destinations.cities.Wuhan',
      'destinations.cities.Nanjing',
    ],
  },
  {
    code: 'HK',
    nameKey: 'destinations.countries.HK',
    flag: '🇭🇰',
    cityKeys: ['destinations.cities.HongKong'],
  },
  {
    code: 'MO',
    nameKey: 'destinations.countries.MO',
    flag: '🇲🇴',
    cityKeys: ['destinations.cities.Macau'],
  },
  {
    code: 'TW',
    nameKey: 'destinations.countries.TW',
    flag: '🇹🇼',
    cityKeys: [
      'destinations.cities.Taipei',
      'destinations.cities.Kaohsiung',
      'destinations.cities.Taichung',
      'destinations.cities.Tainan',
    ],
  },
  {
    code: 'JP',
    nameKey: 'destinations.countries.JP',
    flag: '🇯🇵',
    cityKeys: [
      'destinations.cities.Tokyo',
      'destinations.cities.Osaka',
      'destinations.cities.Kyoto',
      'destinations.cities.Nagoya',
      'destinations.cities.Fukuoka',
      'destinations.cities.Sapporo',
    ],
  },
  {
    code: 'KR',
    nameKey: 'destinations.countries.KR',
    flag: '🇰🇷',
    cityKeys: [
      'destinations.cities.Seoul',
      'destinations.cities.Busan',
      'destinations.cities.Daegu',
      'destinations.cities.Incheon',
    ],
  },
  {
    code: 'TH',
    nameKey: 'destinations.countries.TH',
    flag: '🇹🇭',
    cityKeys: [
      'destinations.cities.Bangkok',
      'destinations.cities.ChiangMai',
      'destinations.cities.Phuket',
      'destinations.cities.Pattaya',
    ],
  },
  {
    code: 'SG',
    nameKey: 'destinations.countries.SG',
    flag: '🇸🇬',
    cityKeys: ['destinations.cities.Singapore'],
  },
  {
    code: 'MY',
    nameKey: 'destinations.countries.MY',
    flag: '🇲🇾',
    cityKeys: [
      'destinations.cities.KualaLumpur',
      'destinations.cities.Penang',
      'destinations.cities.Malacca',
      'destinations.cities.JohorBahru',
    ],
  },
  {
    code: 'VN',
    nameKey: 'destinations.countries.VN',
    flag: '🇻🇳',
    cityKeys: [
      'destinations.cities.HoChiMinhCity',
      'destinations.cities.Hanoi',
      'destinations.cities.DaNang',
      'destinations.cities.NhaTrang',
    ],
  },
  {
    code: 'ID',
    nameKey: 'destinations.countries.ID',
    flag: '🇮🇩',
    cityKeys: [
      'destinations.cities.Jakarta',
      'destinations.cities.Bali',
      'destinations.cities.Yogyakarta',
      'destinations.cities.Surabaya',
    ],
  },
  {
    code: 'IN',
    nameKey: 'destinations.countries.IN',
    flag: '🇮🇳',
    cityKeys: [
      'destinations.cities.NewDelhi',
      'destinations.cities.Mumbai',
      'destinations.cities.Bangalore',
      'destinations.cities.Kolkata',
    ],
  },
  {
    code: 'AE',
    nameKey: 'destinations.countries.AE',
    flag: '🇦🇪',
    cityKeys: ['destinations.cities.Dubai', 'destinations.cities.AbuDhabi'],
  },

  // 欧洲热门国家
  {
    code: 'GB',
    nameKey: 'destinations.countries.GB',
    flag: '🇬🇧',
    cityKeys: [
      'destinations.cities.London',
      'destinations.cities.Edinburgh',
      'destinations.cities.Manchester',
      'destinations.cities.Liverpool',
    ],
  },
  {
    code: 'FR',
    nameKey: 'destinations.countries.FR',
    flag: '🇫🇷',
    cityKeys: [
      'destinations.cities.Paris',
      'destinations.cities.Lyon',
      'destinations.cities.Marseille',
      'destinations.cities.Nice',
    ],
  },
  {
    code: 'DE',
    nameKey: 'destinations.countries.DE',
    flag: '🇩🇪',
    cityKeys: [
      'destinations.cities.Berlin',
      'destinations.cities.Munich',
      'destinations.cities.Hamburg',
      'destinations.cities.Frankfurt',
    ],
  },
  {
    code: 'IT',
    nameKey: 'destinations.countries.IT',
    flag: '🇮🇹',
    cityKeys: [
      'destinations.cities.Rome',
      'destinations.cities.Milan',
      'destinations.cities.Venice',
      'destinations.cities.Florence',
    ],
  },
  {
    code: 'ES',
    nameKey: 'destinations.countries.ES',
    flag: '🇪🇸',
    cityKeys: [
      'destinations.cities.Madrid',
      'destinations.cities.Barcelona',
      'destinations.cities.Valencia',
      'destinations.cities.Seville',
    ],
  },
  {
    code: 'NL',
    nameKey: 'destinations.countries.NL',
    flag: '🇳🇱',
    cityKeys: [
      'destinations.cities.Amsterdam',
      'destinations.cities.Rotterdam',
      'destinations.cities.TheHague',
    ],
  },
  {
    code: 'CH',
    nameKey: 'destinations.countries.CH',
    flag: '🇨🇭',
    cityKeys: [
      'destinations.cities.Zurich',
      'destinations.cities.Geneva',
      'destinations.cities.Basel',
    ],
  },

  // 北美洲热门国家
  {
    code: 'US',
    nameKey: 'destinations.countries.US',
    flag: '🇺🇸',
    cityKeys: [
      'destinations.cities.NewYork',
      'destinations.cities.LosAngeles',
      'destinations.cities.Chicago',
      'destinations.cities.SanFrancisco',
      'destinations.cities.LasVegas',
      'destinations.cities.Miami',
    ],
  },
  {
    code: 'CA',
    nameKey: 'destinations.countries.CA',
    flag: '🇨🇦',
    cityKeys: [
      'destinations.cities.Toronto',
      'destinations.cities.Vancouver',
      'destinations.cities.Montreal',
      'destinations.cities.Ottawa',
    ],
  },

  // 大洋洲热门国家
  {
    code: 'AU',
    nameKey: 'destinations.countries.AU',
    flag: '🇦🇺',
    cityKeys: [
      'destinations.cities.Sydney',
      'destinations.cities.Melbourne',
      'destinations.cities.Brisbane',
      'destinations.cities.Perth',
    ],
  },
  {
    code: 'NZ',
    nameKey: 'destinations.countries.NZ',
    flag: '🇳🇿',
    cityKeys: [
      'destinations.cities.Auckland',
      'destinations.cities.Wellington',
      'destinations.cities.Christchurch',
    ],
  },
];

/**
 * 解析后的国家信息（包含翻译后的文本）
 */
export interface Country {
  code: string;
  name: string;
  flag: string;
  cities: string[];
}

/**
 * 工具函数：根据代码查找国家
 */
export const getCountryByCode = (
  countries: Country[],
  code: string
): Country | undefined => {
  return countries.find((country) => country.code === code);
};

/**
 * 工具函数：搜索国家（根据名称）
 */
export const searchCountries = (
  countries: Country[],
  query: string
): Country[] => {
  if (!query.trim()) return countries;

  const lowerQuery = query.toLowerCase();
  return countries.filter(
    (country) =>
      country.name.toLowerCase().includes(lowerQuery) ||
      country.cities.some((city) => city.toLowerCase().includes(lowerQuery))
  );
};

/**
 * 工具函数：搜索城市（返回匹配的国家和城市）
 */
export const searchCities = (
  countries: Country[],
  query: string
): Array<{ country: Country; city: string }> => {
  if (!query.trim()) return [];

  const lowerQuery = query.toLowerCase();
  const results: Array<{ country: Country; city: string }> = [];

  countries.forEach((country) => {
    country.cities.forEach((city) => {
      if (city.toLowerCase().includes(lowerQuery)) {
        results.push({ country, city });
      }
    });
  });

  return results;
};
